// Navigation only, never authorization. Review access is checked by verified email.
export const REVIEW_RETURN_COOKIE = "nc_review_return";
export function reviewReturnPath(value: string | null | undefined) {
  return value && /^(?:\/(?:review-invitation|manuscript-request|author-review)\/[a-z0-9]{20,40}|\/editors(?:\/[a-z0-9]{20,40})?)$/.test(value) ? value : null;
}
export function reviewReturnWorkspace(value: string | null | undefined) {
  const path = reviewReturnPath(value);
  return path ? /^\/(manuscript-request|author-review)\//.test(path) ? "writer" : "editor" : null;
}
